import { PayloadAction } from '@reduxjs/toolkit'
import { StudioState } from '../initialState'
import { MAX_ZOOM, MIN_ZOOM, ZOOM_STEP } from 'Vendor/Utils/Constants'

export const uiReducers = {
    responsiveModeToggled: (state: StudioState) => {
        state.responsiveMode =
            state.responsiveMode === 'desktop' ? 'mobile' : 'desktop'
    },

    zoomIn: (state: StudioState) => {
        state.zoomLevel = Math.min(MAX_ZOOM, state.zoomLevel + ZOOM_STEP)
    },

    zoomOut: (state: StudioState) => {
        state.zoomLevel = Math.max(MIN_ZOOM, state.zoomLevel - ZOOM_STEP)
    },

    zoomTo: (state: StudioState, action: PayloadAction<number>) => {
        state.zoomLevel = action.payload
    },

    gridVisibilityToggled: (state: StudioState) => {
        state.isGridVisible = !state.isGridVisible
    },
}
